import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-circle-disable.png'

const CircleDisableBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default CircleDisableBtn
